import { useQuery } from "@msuite/ui/query";
import { guardArray } from "@msuite/utils/array";
import { getFileInbox } from "@/api/files";

/**
 * The dropped files nothing could file.
 *
 * Fetched rather than synced, unlike the pill's live counts: the pill watches one person's batch
 * for the minute it takes to settle, while this is a worklist somebody opens, works through and
 * closes. What it does share is the source — both read the classification's own state, because a
 * sweep for files with no link row would report every workspace logo as unfiled.
 */
export function useFileInbox() {
	/** Query */
	const query = useQuery({
		queryKey: ["file-inbox"],
		queryFn: getFileInbox,
	});

	/** Return */
	return { ...query, files: guardArray(query.data) };
}
